import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["destroyField", "item", "fileInput", "error", "displayName", "uploadLabel", "saveButton"];

  connect() {
    this.clearError();
    this.setFilenameColumnWidth();
    window.addEventListener('resize', this._handleResize = () => { this.setFilenameColumnWidth(); });
  }

  disconnect() {
    if (this._handleResize) {
      window.removeEventListener('resize', this._handleResize);
    }
  }

  deleteExisting(event) {
    const button = event.currentTarget;
    const item = button.closest('[data-organization--meeting-vote-attachments-target="item"]');
    if (!item) return;

    const destroyField = item.querySelector('[data-organization--meeting-vote-attachments-target="destroyField"]');
    if (destroyField) {
      destroyField.value = "1";
    }

    item.classList.add("is-marked-for-deletion");
    item.setAttribute("aria-hidden", "true");
    this.setFilenameColumnWidth();
  }

  validateFile(event) {
    const input = event.currentTarget;
    if (!input.files || input.files.length === 0) {
      this.clearError();
      this.setFilenameColumnWidth();
      this._toggleSave(false);
      return;
    }
    const file = input.files[0];
    const typesAttr = this.element.getAttribute('data-allowed-types') || '';
    const allowed = typesAttr.split(',').map(t => t.trim()).filter(Boolean);
    if (!allowed.includes(file.type)) {
      this.showError('File format not supported');
      input.value = '';
      this.setFilenameColumnWidth();
      this._toggleSave(false);
    } else {
      this.clearError();
      if (this.hasDisplayNameTarget) {
        if (!this.displayNameTarget.value || this.displayNameTarget.value.trim() === '') {
            const baseName = file.name.replace(/\.[^.]+$/,'');
            this.displayNameTarget.value = baseName;
        }
        requestAnimationFrame(() => {
          this.displayNameTarget.focus();
          this.displayNameTarget.select();
        });
      }
      this.setFilenameColumnWidth();
      this._toggleSave(true);
    }
  }

  saveFile() {
    const form = this.element.closest('form');
    if (!form) return;
    form.requestSubmit ? form.requestSubmit() : form.submit();
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.disabled = true;
    }
  }

  _toggleSave(show) {
    if (this.hasUploadLabelTarget) {
      this.uploadLabelTarget.classList.toggle('is-hidden', show);
    }
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.classList.toggle('is-hidden', !show);
      if (!show) {
        this.saveButtonTarget.disabled = false;
      }
    }
  }

  setFilenameColumnWidth() {
    if (!this.hasItemTarget) return;
    const activeItems = this.itemTargets.filter(item => !item.classList.contains('is-marked-for-deletion'));
    // Reset widths
    activeItems.forEach(item => {
      const span = item.querySelector('.list-filename');
      if (span) span.style.width = 'auto';
    });
    let max = 0;
    activeItems.forEach(item => {
      const span = item.querySelector('.list-filename');
      if (span) {
        const width = span.offsetWidth; 
        if (width > max) max = width;
      }
    });
    if (max === 0) return;
    const targetWidth = max; 
    activeItems.forEach(item => {
      const span = item.querySelector('.list-filename');
      if (span) span.style.width = targetWidth + 'px';
    });
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.classList.remove('is-hidden');
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = '';
      this.errorTarget.classList.add('is-hidden');
    }
  }
}
